export default [
  {
    path: "/backoffice/participants/donors",
    name: "DonorsList",
    meta: {
      requiresAuth: true,
      breadcrumb: [
        { label: "BackOffice", to: "/" },
        { label: "Participants" },
        { label: "Donors" },
      ],
    },
    component: () =>
      import(
        /* webpackChunkName: "participants" */ "@/views/backoffice/Participants/DonorsList.vue"
      ),
  },
  {
    path: "/backoffice/participants/donors/create",
    name: "DonorsCreate",
    meta: {
      requiresAuth: true,
      breadcrumb: [
        { label: "BackOffice", to: "/" },
        { label: "Participants" },
        { label: "Donors", to: "/backoffice/participants/donors" },
        { label: "Create" },
      ],
    },
    component: () =>
      import(
        /* webpackChunkName: "participants-donors" */ "@/views/backoffice/Participants/DonorsCreatePage.vue"
      ),
  },
  {
    path: "/backoffice/participants/donors/:id",
    name: "DonorDetail",
    meta: {
      requiresAuth: true,
      breadcrumb: [
        { label: "BackOffice", to: "/" },
        { label: "Participants" },
        { label: "Donors", to: "/backoffice/participants/donors" },
        { label: "Detail" },
      ],
    },
    component: () =>
      import(
        /* webpackChunkName: "participants-donors" */ "@/views/backoffice/Participants/DonorsCreatePage.vue"
      ),
  },
  {
    path: "/backoffice/participants/donors/:id/edit",
    name: "DonorEdit",
    meta: {
      requiresAuth: true,
      breadcrumb: [
        { label: "BackOffice", to: "/" },
        { label: "Participants" },
        { label: "Donors", to: "/backoffice/participants/donors" },
        { label: "Edit" },
      ],
    },
    component: () =>
      import(
        /* webpackChunkName: "participants-donors" */ "@/views/backoffice/Participants/DonorsCreatePage.vue"
      ),
  },
  {
    path: "/backoffice/participants/agencies",
    name: "AgenciesList",
    meta: {
      requiresAuth: true,
      breadcrumb: [
        { label: "BackOffice", to: "/" },
        { label: "Participants" },
        { label: "Agencies" },
      ],
    },
    component: () =>
      import(
        /* webpackChunkName: "participants" */ "@/views/backoffice/Participants/AgenciesList.vue"
      ),
  },
  {
    path: "/backoffice/participants/agencies/create",
    name: "AgenciesCreate",
    meta: {
      requiresAuth: true,
      breadcrumb: [
        { label: "BackOffice", to: "/" },
        { label: "Participants" },
        { label: "Agencies", to: "/backoffice/participants/agencies" },
        { label: "Create" },
      ],
    },
    component: () =>
      import(
        /* webpackChunkName: "participants-agencies" */ "@/views/backoffice/Participants/AgenciesCreatePage.vue"
      ),
  },
  {
    path: "/backoffice/participants/agencies/:id",
    name: "AgenciesDetail",
    meta: {
      requiresAuth: true,
      breadcrumb: [
        { label: "BackOffice", to: "/" },
        { label: "Participants" },
        { label: "Agencies", to: "/backoffice/participants/agencies" },
        { label: "Detail" },
      ],
    },
    component: () =>
      import(
        /* webpackChunkName: "participants-agencies" */ "@/views/backoffice/Participants/AgenciesCreatePage.vue"
      ),
  },
  {
    path: "/backoffice/participants/agencies/:id/edit",
    name: "AgenciesEdit",
    meta: {
      requiresAuth: true,
      breadcrumb: [
        { label: "BackOffice", to: "/" },
        { label: "Participants" },
        { label: "Agencies", to: "/backoffice/participants/agencies" },
        { label: "Edit" },
      ],
    },
    component: () =>
      import(
        /* webpackChunkName: "participants-agencies" */ "@/views/backoffice/Participants/AgenciesCreatePage.vue"
      ),
  },
  {
    path: "/backoffice/participants/partners",
    name: "PartnersList",
    meta: {
      requiresAuth: true,
      breadcrumb: [
        { label: "BackOffice", to: "/" },
        { label: "Participants" },
        { label: "Partners" },
      ],
    },
    component: () =>
      import(
        /* webpackChunkName: "participants" */ "@/views/backoffice/Participants/PartnersList.vue"
      ),
  },
  {
    path: "/backoffice/participants/partners/:id",
    name: "PartnersDetail",
    meta: {
      requiresAuth: true,
      breadcrumb: [
        { label: "BackOffice", to: "/" },
        { label: "Participants" },
        { label: "Partners", to: "/backoffice/participants/partners" },
        { label: "Detail" },
      ],
    },
    component: () =>
      import(
        /* webpackChunkName: "participants-partners" */ "@/views/backoffice/Participants/PartnersCreatePage.vue"
      ),
  },
  {
    path: "/backoffice/participants/partners/:id/edit",
    name: "PartnersEdit",
    meta: {
      requiresAuth: true,
      breadcrumb: [
        { label: "BackOffice", to: "/" },
        { label: "Participants" },
        { label: "Partners", to: "/backoffice/participants/partners" },
        { label: "Edit" },
      ],
    },
    component: () =>
      import(
        /* webpackChunkName: "participants-partners" */ "@/views/backoffice/Participants/PartnersCreatePage.vue"
      ),
  },
  {
    path: "/backoffice/participants/partners/create",
    name: "PartnersCreate",
    meta: {
      requiresAuth: true,
      breadcrumb: [
        { label: "BackOffice", to: "/" },
        { label: "Participants" },
        { label: "Partners", to: "/backoffice/participants/partners" },
        { label: "Create" },
      ],
    },
    component: () =>
      import(
        /* webpackChunkName: "participants-partners" */ "@/views/backoffice/Participants/PartnersCreatePage.vue"
      ),
  },
  {
    path: "/backoffice/participants/beneficiaries",
    name: "BeneficiariesList",
    meta: {
      requiresAuth: true,
      breadcrumb: [
        { label: "BackOffice", to: "/" },
        { label: "Participants" },
        { label: "Beneficiaries" },
      ],
    },
    component: () =>
      import("@/views/backoffice/Participants/BeneficiariesList.vue"),
  },
  {
    path: "/backoffice/participants/beneficiaries/create",
    name: "BeneficiariesCreate",
    meta: {
      requiresAuth: true,
      breadcrumb: [
        { label: "BackOffice", to: "/" },
        { label: "Participants" },
        { label: "Beneficiaries", to: "/backoffice/participants/beneficiaries" },
        { label: "Create" },
      ],
    },
    component: () =>
      import(
        /* webpackChunkName: "participants-beneficiaries" */ "@/views/backoffice/Participants/BeneficiariesCreatePage.vue"
      ),
  },
  // TODO(temporary): CSV beneficiaries import route — START of temporary block, remove entirely when no longer needed
  {
    path: "/backoffice/participants/beneficiaries/import",
    name: "BeneficiariesImport",
    meta: {
      requiresAuth: true,
      breadcrumb: [
        { label: "BackOffice", to: "/" },
        { label: "Participants" },
        { label: "Beneficiaries", to: "/backoffice/participants/beneficiaries" },
        { label: "Import CSV" },
      ],
    },
    component: () =>
      import(
        /* webpackChunkName: "participants-beneficiaries" */ "@/views/backoffice/Participants/BeneficiariesImportPage.vue"
      ),
  },
  // TODO(temporary): CSV beneficiaries import route — END of temporary block
  {
    path: "/backoffice/participants/beneficiaries/:id",
    name: "BeneficiariesDetail",
    meta: {
      requiresAuth: true,
      breadcrumb: [
        { label: "BackOffice", to: "/" },
        { label: "Participants" },
        { label: "Beneficiaries", to: "/backoffice/participants/beneficiaries" },
        { label: "Detail" },
      ],
    },
    component: () =>
      import(
        /* webpackChunkName: "participants-beneficiaries" */ "@/views/backoffice/Participants/BeneficiariesCreatePage.vue"
      ),
  },
  {
    path: "/backoffice/participants/beneficiaries/:id/edit",
    name: "BeneficiariesEdit",
    meta: {
      requiresAuth: true,
      breadcrumb: [
        { label: "BackOffice", to: "/" },
        { label: "Participants" },
        { label: "Beneficiaries", to: "/backoffice/participants/beneficiaries" },
        { label: "Edit" },
      ],
    },
    component: () =>
      import(
        /* webpackChunkName: "participants-beneficiaries" */ "@/views/backoffice/Participants/BeneficiariesCreatePage.vue"
      ),
  },
  {
    path: "/backoffice/participants/merchants",
    name: "MerchantsList",
    meta: {
      requiresAuth: true,
      breadcrumb: [
        { label: "BackOffice", to: "/" },
        { label: "Participants" },
        { label: "Merchants" },
      ],
    },
    component: () =>
      import("@/views/backoffice/Participants/MerchantsList.vue"),
  },
  {
    path: "/backoffice/participants/merchants/:id",
    name: "MerchantsDetail",
    meta: {
      requiresAuth: true,
      breadcrumb: [
        { label: "BackOffice", to: "/" },
        { label: "Participants" },
        { label: "Merchants", to: "/backoffice/participants/merchants" },
        { label: "Detail" },
      ],
    },
    component: () =>
      import(
        /* webpackChunkName: "participants-merchants" */ "@/views/backoffice/Participants/MerchantsCreatePage.vue"
      ),
  },
  {
    path: "/backoffice/participants/merchants/:id/edit",
    name: "MerchantsEdit",
    meta: {
      requiresAuth: true,
      breadcrumb: [
        { label: "BackOffice", to: "/" },
        { label: "Participants" },
        { label: "Merchants", to: "/backoffice/participants/merchants" },
        { label: "Edit" },
      ],
    },
    component: () =>
      import(
        /* webpackChunkName: "participants-merchants" */ "@/views/backoffice/Participants/MerchantsCreatePage.vue"
      ),
  },
  {
    path: "/backoffice/participants/merchants/create",
    name: "MerchantsCreate",
    meta: {
      requiresAuth: true,
      breadcrumb: [
        { label: "BackOffice", to: "/" },
        { label: "Participants" },
        { label: "Merchants", to: "/backoffice/participants/merchants" },
        { label: "Create" },
      ],
    },
    component: () =>
      import(
        /* webpackChunkName: "participants-merchants" */ "@/views/backoffice/Participants/MerchantsCreatePage.vue"
      ),
  },
  {
    path: "/backoffice/participants/banks",
    name: "BanksList",
    meta: {
      requiresAuth: true,
      breadcrumb: [
        { label: "BackOffice", to: "/" },
        { label: "Participants" },
        { label: "Banks" },
      ],
    },
    component: () =>
      import(
        /* webpackChunkName: "participants" */ "@/views/backoffice/Participants/BankList.vue"
      ),
  },
  {
    path: "/backoffice/participants/banks/create",
    name: "BanksCreate",
    meta: {
      requiresAuth: true,
      breadcrumb: [
        { label: "BackOffice", to: "/" },
        { label: "Participants" },
        { label: "Banks", to: "/backoffice/participants/banks" },
        { label: "Create" },
      ],
    },
    component: () =>
      import(
        /* webpackChunkName: "participants-banks" */ "@/views/backoffice/Participants/BankCreatePage.vue"
      ),
  },
  {
    path: "/backoffice/participants/banks/:id",
    name: "BanksDetail",
    meta: {
      requiresAuth: true,
      breadcrumb: [
        { label: "BackOffice", to: "/" },
        { label: "Participants" },
        { label: "Banks", to: "/backoffice/participants/banks" },
        { label: "Detail" },
      ],
    },
    component: () =>
      import(
        /* webpackChunkName: "participants-banks" */ "@/views/backoffice/Participants/BankCreatePage.vue"
      ),
  },
  {
    path: "/backoffice/participants/banks/:id/edit",
    name: "BanksEdit",
    meta: {
      requiresAuth: true,
      breadcrumb: [
        { label: "BackOffice", to: "/" },
        { label: "Participants" },
        { label: "Banks", to: "/backoffice/participants/banks" },
        { label: "Edit" },
      ],
    },
    component: () =>
      import(
        /* webpackChunkName: "participants-banks" */ "@/views/backoffice/Participants/BankCreatePage.vue"
      ),
  },
  {
    path: "/backoffice/participants/authorities",
    name: "AuthoritiesList",
    meta: {
      requiresAuth: true,
      breadcrumb: [
        { label: "BackOffice", to: "/" },
        { label: "Participants" },
        { label: "Authorities" },
      ],
    },
    component: () =>
      import("@/views/backoffice/Participants/AuthoritiesList.vue"),
  },
  {
    path: "/backoffice/participants/authorities/create",
    name: "AuthoritiesCreate",
    meta: {
      requiresAuth: true,
      breadcrumb: [
        { label: "BackOffice", to: "/" },
        { label: "Participants" },
        { label: "Authorities", to: "/backoffice/participants/authorities" },
        { label: "Create" },
      ],
    },
    component: () =>
      import(
        /* webpackChunkName: "participants-authorities" */ "@/views/backoffice/Participants/AuthoritiesCreatePage.vue"
      ),
  },
  {
    path: "/backoffice/participants/authorities/:id",
    name: "AuthoritiesDetail",
    meta: {
      requiresAuth: true,
      breadcrumb: [
        { label: "BackOffice", to: "/" },
        { label: "Participants" },
        { label: "Authorities", to: "/backoffice/participants/authorities" },
        { label: "Detail" },
      ],
    },
    component: () =>
      import(
        /* webpackChunkName: "participants-authorities" */ "@/views/backoffice/Participants/AuthoritiesCreatePage.vue"
      ),
  },
  {
    path: "/backoffice/participants/authorities/:id/edit",
    name: "AuthoritiesEdit",
    meta: {
      requiresAuth: true,
      breadcrumb: [
        { label: "BackOffice", to: "/" },
        { label: "Participants" },
        { label: "Authorities", to: "/backoffice/participants/authorities" },
        { label: "Edit" },
      ],
    },
    component: () =>
      import(
        /* webpackChunkName: "participants-authorities" */ "@/views/backoffice/Participants/AuthoritiesCreatePage.vue"
      ),
  },
];
